// extracted by mini-css-extract-plugin
export default {"ul":"_3stV","link":"_1lt_","linkActive":"_2X4p"};